import isEqual from "react-fast-compare";
import {
  TourAction,
  TourAddAction,
  TourNewAction,
  TourRemoveAction,
  TourState,
} from "../types";

export const initialState: TourState = {
  tours: [],
  loading: false,
  error: null,
  selectedDate: new Date(),
};

export function tourReducer(state: TourState, action: TourAction): TourState {
  switch (action.type) {
    case "new": {
      return handleNewAction(state, action);
    }
    case "add": {
      return handleAddAction(state, action);
    }
    case "error": {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case "remove": {
      return handleRemoveAction(state, action);
    }
    default:
      return state;
  }
}

export function handleNewAction(
  state: TourState,
  action: TourNewAction,
): TourState {
  if (isEqual(state, action.newState)) {
    return state;
  }

  return {
    ...action.newState,
  };
}

export function handleAddAction(
  state: TourState,
  action: TourAddAction,
): TourState {
  return {
    ...state,
    tours: [...state.tours, action.newTour],
  };
}

export function handleRemoveAction(
  state: TourState,
  action: TourRemoveAction,
): TourState {
  return {
    ...state,
    tours: state.tours.filter((tour) => tour.id !== action.tourId),
  };
}
